export * from "./info-label";
